export default __webpack_public_path__ + "static/media/candyBoxMenu.b2c3b92b.svg";